export default __webpack_public_path__ + "static/media/icons8-update-left-rotation-48.63bb1b30.svg";